import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthGuard from '../component/auth-guard/AuthGuard';
import Layout from '../component/layout/Layout';
import { CardDetailProvider } from '../context/CardDetailContext';
import BalanceRecord from '../page/Balance-record';
import BankPage from '../page/Bank-management';
import CardTypePage from '../page/Card-type-management';
import CreditCardsPage from '../page/Credit-cards';
import CustomerPage from '../page/customer/Customer-management';
import CustomerDetail from '../page/customer/CustomerDetail';
import EmployeePage from '../page/employee/Employee-manage';
import EmployeeDetail from '../page/employee/EmployeeDetail';
import FeeSchedulePage from '../page/FeeSchedule';

import LoginPage from '../page/Login';

import POSDevicePage from '../page/POS-device-management';
import Unauthorized from '../page/Unauthorized';
import AllAccBalance from '../page/All-acc-balance';
import Partner from '../page/Partner';
import Dept from '../page/Dept';
import FundTransfer from '../page/FundTransfer';
import MaturitySchedule from '../page/Maturity-schedule';
import CardDetail from '../page/card-detail';
import WithdrawalCheck from '../page/WithdrawalCheck';
import MaturityTransactionsByMonth from '../page/Maturity-transactions-by-month';
import MaturityPayments from '../page/Maturity-payments';
import WithdrawalServicePage from '../page/Withdrawal-service-page';
import Financial from '../page/Finacial';
import MaturityCreatedToday from '../page/Maturity-created-today';
import ProfitReport from '../page/Profit-report';
import Home3 from '../page/Home3';

const MainRoutes: React.FC = () => {
  return (
    <CardDetailProvider>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
              <Layout />
            </AuthGuard>
          }
        >
          <Route
            index
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <Home3 />
              </AuthGuard>
            }
          />

          <Route
            path="bank"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <BankPage />
              </AuthGuard>
            }
          />
          <Route
            path="card-type"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <CardTypePage />
              </AuthGuard>
            }
          />
          <Route
            path="credit-cards"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <CreditCardsPage />
              </AuthGuard>
            }
          />
          <Route
            path="pos-device"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <POSDevicePage />
              </AuthGuard>
            }
          />
          <Route
            path="customer"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <CustomerPage />
              </AuthGuard>
            }
          />
          <Route
            path="customer/:id"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <CustomerDetail />
              </AuthGuard>
            }
          />

          <Route
            path="employee"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <EmployeePage />
              </AuthGuard>
            }
          />
          <Route
            path="employee/:id"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <EmployeeDetail />
              </AuthGuard>
            }
          />
          <Route
            path="fee-schedule"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <FeeSchedulePage />
              </AuthGuard>
            }
          />

          <Route
            path="/balance-record"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <BalanceRecord />
              </AuthGuard>
            }
          />

          <Route
            path="/all-accounts-balance"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <AllAccBalance />
              </AuthGuard>
            }
          />

          <Route
            path="/partner"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <Partner />
              </AuthGuard>
            }
          />

          <Route
            path="/dept"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <Dept />
              </AuthGuard>
            }
          />

          <Route
            path="/fund-transfer"
            element={
              <AuthGuard allowedRoles={['ROLE_EMPLOYEE']}>
                <FundTransfer />
              </AuthGuard>
            }
          />

          <Route
            path="/maturity-schedule"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <MaturitySchedule />
              </AuthGuard>
            }
          />

          <Route
            path="/card-detail"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <CardDetail />
              </AuthGuard>
            }
          />

          <Route
            path="/withdrawal-check"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <WithdrawalCheck />
              </AuthGuard>
            }
          />

          <Route
            path="/maturity-transactions-by-month"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <MaturityTransactionsByMonth />
              </AuthGuard>
            }
          />

          <Route
            path="/maturity-payments"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <MaturityPayments />
              </AuthGuard>
            }
          />

          <Route
            path="/withdrawal-service"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <WithdrawalServicePage />
              </AuthGuard>
            }
          />

          <Route
            path="/financial"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN', 'ROLE_EMPLOYEE']}>
                <Financial />
              </AuthGuard>
            }
          />

          <Route
            path="/maturity-created-today"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <MaturityCreatedToday />
              </AuthGuard>
            }
          />

          <Route
            path="/profit-report"
            element={
              <AuthGuard allowedRoles={['ROLE_ADMIN']}>
                <ProfitReport />
              </AuthGuard>
            }
          />
        </Route>

        {/* Redirect unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </CardDetailProvider>
  );
};

export default MainRoutes;
